import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, mergeProps as _mergeProps, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "w-full flex flex-col gap-y-2 text-left h-80" }
const _hoisted_2 = { class: "flex flex-col gap-6" }
const _hoisted_3 = { class: "flex items-center justify-between flex-wrap gap-4" }
const _hoisted_4 = { class: "w-full text-sm" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"grid grid-cols-12 py-1 font-semibold px-2 text-gray-700\"><div class=\"col-span-4 font-bold text-md text-black\">Nome</div><div class=\"col-span-3 font-bold text-md text-black\">Período</div><div class=\"col-span-3 font-bold text-md text-black\">Criado por</div><div class=\"col-span-2 text-right px-4\">Ações</div></div>", 1)
const _hoisted_6 = { class: "col-span-4 flex items-center gap-2" }
const _hoisted_7 = ["data-testid"]
const _hoisted_8 = { class: "col-span-3" }
const _hoisted_9 = { class: "col-span-3" }
const _hoisted_10 = { class: "col-span-2 flex items-center justify-end gap-3 px-2" }

import { mdiPlus, mdiMagnify } from '@mdi/js'
import DsSwitch from '@/components/designSystem/Switch/index.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import EditIcon from '@/assets/icons/edit.vue'
import Legend from '@/components/designSystem/Legend/Legend.vue'
import { DSAttendanceVigencyStatus } from '@/constants/ds-attendance.constants'

interface LegendItem {
  label: string
  borderColor: string
  bgColor: string
}

interface BasePolicyItem {
  id?: number | string
  name: string
  isActive?: boolean
  vigencyStatus?: DSAttendanceVigencyStatus
  isInEffect?: boolean
  createdBy?: { name: string } | null
  links?: { isActive?: boolean; startDate: string | Date | null; endDate?: string | Date | null }[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BasePolicyTable',
  props: {
    search: {},
    policies: {},
    isLoading: { type: Boolean },
    loadingSwitches: {},
    canCreate: { type: Boolean },
    canEdit: { type: Boolean },
    legendItems: { default: () => [
      { label: 'Em vigência', borderColor: 'border-green-500', bgColor: 'bg-green-100' }
    ] }
  },
  emits: ['update:search', 'create', 'edit', 'toggle-status'],
  setup(__props: any) {



const VIGENCY_DOT_MAP: Partial<Record<DSAttendanceVigencyStatus, string>> = {
  [DSAttendanceVigencyStatus.IN_EFFECT]: 'border-green-500 bg-green-100',
  [DSAttendanceVigencyStatus.EXPIRED]: 'border-red-500 bg-red-100',
  [DSAttendanceVigencyStatus.FUTURE]: 'border-blue-500 bg-blue-100'
}

const getVigencyDotClasses = (policy: {
  vigencyStatus?: DSAttendanceVigencyStatus
  isInEffect?: boolean
}): string | null => {
  if (policy.vigencyStatus) {
    return VIGENCY_DOT_MAP[policy.vigencyStatus] ?? null
  }
  if (policy.isInEffect) {
    return VIGENCY_DOT_MAP[DSAttendanceVigencyStatus.IN_EFFECT]!
  }
  return null
}



const formatDateToBR = (value: string | Date | null | undefined): string => {
  if (!value) return '-'
  const date = value instanceof Date ? value : new Date(value)
  if (isNaN(date.getTime())) return '-'
  const day = String(date.getUTCDate()).padStart(2, '0')
  const month = String(date.getUTCMonth() + 1).padStart(2, '0')
  const year = date.getUTCFullYear()
  return `${day}/${month}/${year}`
}

const formatPeriod = (policy: BasePolicyItem): string => {
  const activeLink =
    policy.links?.find((link) => link.isActive) ?? policy.links?.[policy.links.length - 1] ?? null

  if (!activeLink) return '-'

  const start = formatDateToBR(activeLink.startDate)
  const end = activeLink.endDate ? formatDateToBR(activeLink.endDate) : 'Indeterminado'

  return `${start} à ${end}`
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_text_field, {
        "model-value": _ctx.search,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:search', $event))),
        placeholder: "Buscar política",
        "append-inner-icon": _unref(mdiMagnify),
        density: "compact",
        variant: "outlined",
        "hide-details": "",
        class: "w-full md:w-80 h-8",
        color: "primary20"
      }, null, 8, ["model-value", "append-inner-icon"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(Legend, {
          items: _ctx.legendItems,
          class: "text-sm text-gray-600"
        }, null, 8, ["items"]),
        (_ctx.canCreate)
          ? (_openBlock(), _createBlock(OutlineButton, {
              key: 0,
              text: "Nova política",
              "append-icon": _unref(mdiPlus),
              class: "!px-4 !py-1 text-sm !w-[160px]",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('create')))
            }, null, 8, ["append-icon"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_v_progress_linear, {
            key: 0,
            indeterminate: "",
            color: "primary",
            class: "mt-6"
          }))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.policies, (policy, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["grid grid-cols-12 items-center px-2 py-3 border-b", { 'text-gray-300': !policy.isActive }])
        }, [
          _createElementVNode("div", _hoisted_6, [
            (getVigencyDotClasses(policy))
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  "data-testid": `vigency-dot-${policy.vigencyStatus ?? 'active'}`,
                  class: _normalizeClass(["w-2.5 h-2.5 rounded-full border inline-block", getVigencyDotClasses(policy)])
                }, null, 10, _hoisted_7))
              : _createCommentVNode("", true),
            _createElementVNode("span", null, _toDisplayString(policy.name), 1)
          ]),
          _createElementVNode("div", _hoisted_8, _toDisplayString(formatPeriod(policy)), 1),
          _createElementVNode("div", _hoisted_9, _toDisplayString(policy.createdBy?.name ?? '-'), 1),
          _createElementVNode("div", _hoisted_10, [
            (_ctx.canEdit)
              ? (_openBlock(), _createBlock(_component_v_tooltip, {
                  key: 0,
                  text: "Editar"
                }, {
                  activator: _withCtx(({ props }) => [
                    _createVNode(EditIcon, _mergeProps(props, {
                      color: policy.isActive ? '#2f7f91' : '#D1D5DB',
                      class: "cursor-pointer w-5 h-5",
                      onClick: ($event: any) => (policy.isActive && _ctx.$emit('edit', policy))
                    }), null, 16, ["color", "onClick"])
                  ]),
                  _: 2
                }, 1024))
              : _createCommentVNode("", true),
            _createVNode(_component_v_tooltip, {
              text: policy.isActive ? 'Desativar' : 'Ativar'
            }, {
              activator: _withCtx(({ props: tooltipProps }) => [
                _createElementVNode("span", _mergeProps(tooltipProps, { class: "inline-flex" }), [
                  _createVNode(DsSwitch, {
                    "model-value": policy.isActive ?? false,
                    loading: _ctx.loadingSwitches.has(Number(policy.id)),
                    "onUpdate:modelValue": 
                    (val) => _ctx.$emit('toggle-status', Number(policy.id), val)
                  
                  }, null, 8, ["model-value", "loading", "onUpdate:modelValue"])
                ], 16)
              ]),
              _: 2
            }, 1032, ["text"])
          ])
        ], 2))
      }), 128))
    ])
  ]))
}
}

})